
const specialty = [
  {
    title: 'Meat Lover',
    dozen: 'Dozen $30',
    regular: 'Regular Pan $60',
    large: 'Large Pan $120'
  },

];

const masaMenu = [
  {
    title: 'Masa',
    dozen: 'Dozen $25',
    regular: 'Regular Pan $50',
    large: 'Large Pan $100'
  },
  {
    title: 'Masa & Peanut Soup',
    dozen: 'Dozen $40',
    regular: 'Regular Pan $80',
    large: 'Large Pan $150'
  },
  {
    title: 'Peanut Soup',
    dozen: 'Small 700ml $30',
    regular: 'Regular 1.5L $50',
    large: 'Large 2.2L $70'
  },
];

const chickenMenu = [
  {
    title: 'Sesame Glazed Chicken',
    dozen: 'Regular $60',
    regular: 'Half Pan $120',
    large: 'Large Pan $240'
  },
];

const puffPuffMenu = [
  {
    title: 'RS Puff Puff',
    dozen: 'Regular $30',
    regular: 'Half Pan $50',
    large: 'Large Pan $100'
  },
];

const bunsMenu = [
  {
    title: 'RS Buns',
    regular: 'Half Pan $60',
    large: 'Large Pan $120'
  },
];

const saladsMenu = [
  {
    info: 'Field Greens, Tomato, Cucumber, Black Olives, dried Cranberries, Feta Cheese. Avocado added on request for $5',
    title: 'Field-Vinaigrette',
    regular: 'Regular $50',
    large: 'Large $100',
  },
  {
    info: 'White and Red cabbage, pasta, carrot, cucumber, red onions, tomatoes and boiled eggs. Tuna added on request for $5',
    title: 'Cabbage Mayo',
    regular: 'Regular $50',
    large: 'Large $100',
  },
];

const yogurtMenu = [
  {
    info: 'Yougurt blended with millet the RS way, You need to try this!',
    title: 'RS Yogurt - Fura Da Nono',
    aLiter: '1-Litre $25',
    _500ml: '500ml $15',
    _375ml: '375ml $10',
  },
];

const menuData = { specialty, masaMenu, bunsMenu, puffPuffMenu, chickenMenu, saladsMenu, yogurtMenu };

export default menuData;
